// extracted by mini-css-extract-plugin
export default {"footerInfo":"SiteInfoFooter_footerInfo__dsF4V","buttonClass":"SiteInfoFooter_buttonClass__fC1iu"};